// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"134":"app-messages-Spanish_Ext","147":"app-messages-ChineseWu_Ext","294":"app-messages-en_US"}[chunkId] || chunkId) + "." + {"134":"f3e815c2","147":"e864112e","294":"53ddd3d5","392":"a7e3639c"}[chunkId] + ".chunk.js";
};